export default "__VITE_ASSET__99b2e338__"